var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6329 10.2746L11.675 8.32084C10.9758 7.62307 9.7871 7.90221 9.50741 8.80927C9.29764 9.43729 8.5984 9.78617 7.96909 9.64659C6.57063 9.29771 4.6827 7.48352 4.33308 6.01822C4.12331 5.3902 4.54285 4.69244 5.17216 4.48313C6.08116 4.20403 6.36086 3.01783 5.66162 2.32007L3.70377 0.366326C3.14439 -0.122109 2.30531 -0.122109 1.81584 0.366326L0.4873 1.69208C-0.841242 3.08761 0.627147 6.78576 3.91354 10.0652C7.19994 13.3447 10.9059 14.8798 12.3043 13.4843L13.6329 12.1585C14.1224 11.6003 14.1224 10.763 13.6329 10.2746Z",
    fill: "#969BA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.b788cbc7e9de6fc085bf5569cc8dc1e8.svg";
export { ForwardRef as ReactComponent };